export enum WindowSizeBreakpointsEnum {
  Mobile = 768,
  Tablet = 1200,
}